import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { hasBoards } from '../../services/analysisContentService';
import useTranslate from '../../../common/hooks/useTranslate';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { POPUP } from '../../../redux/types';

import { NavLink } from 'react-router-dom';
import Icon from '../icon/icon';

import './navigation.scss';

const Navigation: React.FC = () => {
  const [showBoards, setShowBoards] = useState<boolean>(true);

  const dispatch = useDispatch();

  const svgContainerClass: string = `svg-container`;
  const svgContainerActiveClass: string = `svg-container-active`;
  const noPropagation = (e: any) => e.stopPropagation();
  const {t} = useTranslate();
  const expanded = useSelector((state: RootState) => state.sidebar.expanded);

  useEffect(() => {
    hasBoards().then((r) => {
      setShowBoards(r.hasBoards);
    }).catch((err) => dispatch({ type: POPUP.SET_SERVER_ERROR, payload: err.message }));
  }, []);

  return (
    <div className='nav-wrapper' onClick={noPropagation}>
      <NavLink end to='/home' className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
        {({ isActive }) =>
          (isActive ?
              <div className="nav-item">
                <Icon name='fas fa-house-user' className='nav-icon' />
                {expanded === '1' && <span>{t('HOME.PAGE_TITLE')}</span>}
              </div> :
              <div className="nav-item">
                <Icon name='far fa-house-user' className='nav-icon' />
                {expanded === '1' && <span>{t('HOME.PAGE_TITLE')}</span>}
              </div>
          )}
      </NavLink>
      {showBoards && (
        <NavLink style={{ marginTop: 30 }} to='/boards' className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
          {({ isActive }) =>
            (isActive ?
                <div className="nav-item">
                  <Icon name='fas fa-chart-line' className='nav-icon' />
                  {expanded === '1' && <span>{t('BOARDS.PAGE_TITLE')}</span>}
                </div> :
                <div className="nav-item">
                  <Icon name='far fa-chart-line' className='nav-icon' />
                  {expanded === '1' && <span>{t('BOARDS.PAGE_TITLE')}</span>}
                </div>
            )}
        </NavLink>
      )}

      <NavLink style={{ marginTop: 30 }} end to='/documents' className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
        {({ isActive }) =>
          isActive ?
            <div className="nav-item">
              <Icon name='fas fa-file-chart-line' className='nav-icon' />
              {expanded === '1' && <span>{t('DOCUMENTS.PAGE_TITLE')}</span>}
            </div> :
            <div className="nav-item">
              <Icon name='far fa-file-chart-line' className='nav-icon' />
              {expanded === '1' && <span>{t('DOCUMENTS.PAGE_TITLE')}</span>}
            </div>
        }
      </NavLink>
    </div>
  );
};

export default Navigation;
